import(/* webpackMode: "eager" */ "/home/foneorders.com/app/src/app/(landing)/about/page.tsx");
